import envConfig from '@acre/config'

import createAxiosInstance from '../utils/createAxiosInstance'

const axiosInstance = createAxiosInstance(
  {
    baseURL: envConfig.GENERAL_INSURANCE_API_URL,
  },
  {
    useApiKey: true,
    useLutherInterceptor: true,
  },
)

export default axiosInstance
